import RTSPUrlGenerator from "../components/RTSPUrlGenerator";

const RTSPUrlGeneratorPage = () => {
  return <RTSPUrlGenerator />;
};

export default RTSPUrlGeneratorPage;
